import React from "react";
import { StyleSheet, Text, View, TouchableOpacity } from "react-native";

const IntroPanel = ({
  buttonColor = "default",
  header,
  buttonText,
  buttonDisabled = false,
  onButtonPress,
  children,
}) => (
  <View style={styles.content}>
    {header && (
      <View style={styles.headingContainer}>
        <View style={styles.line} />
        <Text style={styles.header}>{header}</Text>
        <View style={styles.line} />
      </View>
    )}
    <Text style={styles.customText}>{children}</Text>
    <TouchableOpacity
      disabled={buttonDisabled}
      onPress={onButtonPress}
      style={[
        styles.button,
        {
          backgroundColor:
            buttonColor === "default"
              ? "var(--button-background-color-default)"
              : `var(--module-color-${buttonColor})`,
        },
      ]}
    >
      <Text
        style={[
          styles.buttonText,
          {
            color:
              buttonColor === "default"
                ? "var(--button-text-color-default)"
                : `var(--module-overlay-text-color-${buttonColor})`,
          },
        ]}
      >
        {buttonText}
      </Text>
    </TouchableOpacity>
  </View>
);

export default IntroPanel;

const styles = StyleSheet.create({
  content: {
    alignItems: "center",
  },
  headingContainer: {
    height: 70,
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 32,
  },
  line: {
    width: "60%",
    minWidth: 183,
    height: 1,
    backgroundColor: "#d4d4d4",
    alignSelf: "center",
  },
  header: {
    position: "relative",
    width: "100%",
    height: "var(--module-intro-header-height)",
    alignSelf: "center",
    fontWeight: "var(--font-weight-light)",
    fontSize: "var(--module-intro-header-font-size)",
    letterSpacing: "var(--module-intro-header-letter-spacing)",
    textAlignVertical: "center",
    textAlign: "center",
    color: "var(--text-color-default)",
    textTransform: "uppercase",
  },
  customText: {
    position: "relative",
    width: "var(--module-intro-width)",
    fontSize: "var(--module-intro-font-size)",
    fontStyle: "normal",
    textAlign: "center",
    color: "var(--text-color-alternate)",
    marginBottom: 32,
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--module-intro-letter-spacing)",
  },
  button: {
    minHeight: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    paddingLeft: "var(--button-padding-left)",
    paddingRight: "var(--button-padding-right)",
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: "var(--module-intro-button-font-size)",
    letterSpacing: "var(--button-letter-spacing)",
    textTransform: "uppercase",
  },
});
